import { useGetSessionState } from "raci-react-library";
import { MoreAboutTheAccidentState } from "../../../views/MoreAboutTheAccident/types";
import { FormRoute } from "../../routing/routes.config";

export const useIsClaimCreated = () =>
  !!useGetSessionState<MoreAboutTheAccidentState>(FormRoute.MoreAboutTheAccident).claimNumber;

export default useIsClaimCreated;
